import { VideoPlayer } from 'expo-video';
import { AudioPlayer } from 'expo-audio';

type PlaybackHandle = VideoPlayer | AudioPlayer;

const allHandles = new Set<PlaybackHandle>();

export function registerHandle(handle: VideoPlayer | AudioPlayer) {
  allHandles.add(handle);
}

export function unregisterHandle(handle: PlaybackHandle) {
  allHandles.delete(handle);
}

export function playbackStarted(handle: PlaybackHandle) {
  for (const other of allHandles) {
    if (other !== handle) {
      try {
        if (other.playing) {
          other.pause();
          if ('seekTo' in other) {
            other.seekTo(0);
          } else {
            other.currentTime = 0;
          }
        }
      } catch {}
    }
  }
}
